<template>
    <div ref="chart" class="chart" :class="isVertical ? 'vertical' : ''">
        <div class="numbers" :style="{ width: barsWidth }">
            <div v-for="(number, index) in numberLabels" :key="index">
                <div ref="chartNumber" :id="`chartNumber_${index}`">
                    <span class="text-muted">{{ number }}</span>
                </div>
            </div>
        </div>
        <div class="bars d-flex flex-column flex-md-row" ref="bars">
            <div v-for="(items, flaskNumber) in statsByFlask" :key="flaskNumber" class="d-flex flask flex-fill">
                <div v-for="({ symbol, count, itemId }, itemIndex) in items"
                    :key="itemId" class="d-flex item flex-fill align-items-center"
                    @click="selectSymbol(itemId)"
                    :class="selectedSymbols.includes(itemId) ? 'selected' : ''">
                    <span v-if="hasMultipleFlasks && itemIndex == 0" class="text-muted flask-label">{{ flaskLabel(flaskNumber) }}</span>
                    <div class="symbol" v-if="isVertical">{{ symbol }}</div>
                    <div class="bar"
                        v-b-tooltip.hover
                        :title="count"
                        :style="barStyle(count)">
                    </div>
                    <div class="symbol" v-if="!isVertical">{{ symbol }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { last, head } from 'lodash';
import { syncFrameHeight } from "@tv/helpers";
import $ from "jquery";

export default {
    props: ['gameId', 'selectedSymbols'],

    data() {
        return {
            barsWidth: '100%',
        };
    },

    computed: {
        ...mapState(['shopsGames']),
        ...mapGetters(['isSmallWidth']),

        isVertical() {
            return this.isSmallWidth;
        },

        symbolContainerClasses() {
            if (this.isVertical) {
                return [];
            }

            return ['flex-column'];
        },

        barsContainerClasses() {
            if (this.isVertical) {
                return ['flex-column'];
            }

            return ['align-items-end'];
        },

        game() {
            return Config.games[this.gameId];
        },

        channelId() {
            return this.game.channel_id;
        },

        stats() {
            if(!this.shopsGames[this.game.shop_game_id]) {
                return {};
            }

            return this.shopsGames[this.game.shop_game_id]['guessed_stats'];
        },

        step() {
            return Math.round(this.largestCount * 0.25);
        },

        numberLabels() {
            const labels = [
                this.step * 5,
                this.step * 4,
                this.step * 3,
                this.step * 2,
                this.step * 1,
                0,
            ];

            return labels.map(label => Math.round(label));
        },

        countCeiling() {
            return head(this.numberLabels);
        },

        largestCount() {
            const stats = Object.entries(this.stats)
                .filter(([ id, count ]) => id > 0)
                .filter(([ id ]) => Object.values(this.game.items).find(item => item.studio_item_id == id).symbol != '*')
                .map(([ id, count ]) => count)
                .sort((a, b) => a - b);

            return last(stats);
        },

        hasMultipleFlasks() {
            return Object.keys(this.statsByFlask).length > 1;
        },

        statsByFlask() {
            const flasked = {};

            for (const [ studio_item_id, count ] of Object.entries(this.stats).sort((a, b) => parseInt(a[1]) < parseInt(b[1]) ? 1 : -1)) {
                const [ id, item ] = Object.entries(this.game.items).find(([ id, item ]) => item.studio_item_id == studio_item_id);
                const { flask, symbol } = item;

                if (!flasked[flask]) {
                    flasked[flask] = [];
                }

                if (symbol != '*') {
                    flasked[flask].push({
                        itemId: id,
                        symbol,
                        count: this.stats[studio_item_id] || 0,
                    });
                }
            }

            return flasked;
        },
    },

    methods: {
        selectSymbol(id) {
            this.$emit('selectSymbol', id);
        },

        barStyle(count) {
            const percent = count / this.countCeiling;

            if (this.isVertical) {
                let width = 500;

                if(this.$refs.chart && this.$refs.chartNumber) {
                    width = parseFloat(window.getComputedStyle(this.$refs.chart).width) - parseFloat(window.getComputedStyle(this.$refs.chartNumber[0]).width);
                }

                return { width: percent * width + 'px' };
            }

            return { height: percent * 250 + 'px' };
        },

        flaskLabel(number) {
            const labels = {
                1: 'I',
                2: 'II',
                3: 'III',
                4: 'IV',
                5: 'V',
                6: 'VI',
            };
            return labels[number];
        },
    },

    mounted() {
        this.barsWidth = (this.$refs.bars.scrollWidth + 50) + 'px';
        $(syncFrameHeight);
    },

    updated() {
        this.barsWidth = (this.$refs.bars.scrollWidth + 50) + 'px';
    },
}
</script>
